import { render, staticRenderFns } from "./index.vue?vue&type=template&id=07d5ad7d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=07d5ad7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d5ad7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d5ad7d')) {
      api.createRecord('07d5ad7d', component.options)
    } else {
      api.reload('07d5ad7d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=07d5ad7d&scoped=true&", function () {
      api.rerender('07d5ad7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/components/d2-help/index.vue"
export default component.exports